import React from "react";

function Header(){
    return(
        <header>
            <div className='header'></div>
        </header>
    )
}
export default Header;